import script from "./SettingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsPage.vue?vue&type=script&setup=true&lang=js"

import "./SettingsPage.vue?vue&type=style&index=0&id=2f12c11b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f12c11b"]])

export default __exports__